import React from "react";
import { StyledFormElementsWrapper, FormLabel } from "../styles";
import { CustomFileUpload } from "../../../common/FormInputs";

const AddSignature = ({ values, errors, touched, setFieldValue }) => {
  return (
    <StyledFormElementsWrapper
      style={{ marginBottom: 8, marginTop: 15 }}
      width={"100%"}
    >
      <div style={{ marginTop: 10 }}>
        <FormLabel>
         Add Signatue <span className="required-star"> *</span>
        </FormLabel>
        <CustomFileUpload
          error={touched["addSignature"] && errors["addSignature"]}
          setFile={(file) => setFieldValue("addSignature", file)}
          style={{
            width: "60%",
          }}
          accept="image/*"
          file={{ name: values["addSignature"].name || "" }}
        />
      </div>
    </StyledFormElementsWrapper>
  );
};

export default AddSignature;
